import { useState } from "react";
import useLoading from "../../../components/Common/useLoading";
import InventoryItemsService from "../../../api/Inventory/InventoryItemsService";
import { InventoryItem } from "../../../api/Inventory/Entities/InventoryEntities";

export default function useItem({ itemId, includeStock, includeLastEntry, assignmentType }) {
    const [item, setItem] = useState(new InventoryItem({
        id: 0,
        externalId: 0,
        presentation: ""
    }));
    const [isLoading, setIsLoading] = useLoading({
        onLoad: async () => {
            const result = await InventoryItemsService.GetById({ itemId, includeStock, includeLastEntry, assignmentType });
            setItem(result.Value);
        },
        onError: (error) => {
            setItem(new InventoryItem({
                id: 0,
                externalId: 0,
                presentation: ""
            }))
        }
    });

    return [item, isLoading];
}